(() => {
  'use strict';
  function init(scope = document) {
    scope.querySelectorAll('.kv4-venue-index').forEach(index => {
      if (index.dataset.kv4Ready) return;
      index.dataset.kv4Ready = 'true';
      const section = index.closest('section');
      const panels = [...section.querySelectorAll('[data-kv4-venue-panel]')];
      index.querySelectorAll('[data-kv4-venue]').forEach(row => {
        const show = () => panels.forEach(panel => { panel.hidden = panel.dataset.kv4VenuePanel !== row.dataset.kv4Venue; });
        row.addEventListener('mouseenter', show);
        row.addEventListener('focus', show);
      });
    });
    scope.querySelectorAll('.kv4-crew-request').forEach(request => {
      if (request.dataset.kv4Ready) return;
      request.dataset.kv4Ready = 'true';
      const zip = request.querySelector('#kv4-install-zip');
      const link = request.querySelector('[data-kv4-crew-link]');
      const update = () => {
        zip.value = zip.value.replace(/\D/g, '').slice(0, 5);
        const type = request.querySelector('input[name="kv4-install-type"]:checked');
        const name = type?.closest('label').querySelector('strong')?.textContent || 'Installation';
        const url = new URL('/pages/free-rendering', location.origin);
        url.searchParams.set('form', 'price');
        url.searchParams.set('installation', 'crew');
        url.searchParams.set('project', `Installation crew: ${name}`);
        if (/^\d{5}$/.test(zip.value)) url.searchParams.set('zip', zip.value);
        // Keep the unpublished preview theme in the existing query if present.
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        link.href = url.pathname + url.search;
      };
      request.addEventListener('change', update);
      zip.addEventListener('input', update);
      update();
    });
    const params = new URLSearchParams(location.search);
    if (params.get('installation') === 'crew') {
      scope.querySelectorAll('form[data-hok-inquiry="koval"]').forEach(form => {
        const select = form.querySelector('select[name="contact[Installation]"]');
        const zip = form.querySelector('input[name="contact[ZIP]"]');
        if (select && !select.value) {
          select.value = 'Quote a crew for our site';
          select.dispatchEvent(new Event('change', {bubbles: true}));
        }
        if (zip && !zip.value && /^\d{5}$/.test(params.get('zip') || '')) zip.value = params.get('zip');
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
